import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/c/privacy-policy")({
  component: () => <RouteComponent />,
});

function RouteComponent() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">
        Our Privacy & Security Policies
      </h1>

      <p className="mb-6">
        Safeguarding your privacy and the security of your personal information
        is important to us. Please take a few minutes to read the following
        policies so that you understand how we treat your personal information.
        As we continuously improve and expand our services, these policies might
        change. So please check them out periodically.
      </p>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">
          How we collect information about you
        </h2>
        <ul className="list-disc pl-6 mb-4">
          <li>We collect information that our customers supply to us.</li>
          <li>
            We collect information from emails and other contacts sent to us by
            our customers and users of our website.
          </li>
          <li>
            We collect information electronically on all users of our website,
            including customers, by means of cookies.
          </li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">
          What personal information do we collect?
        </h2>
        <p>
          When you place an order to use our online ordering service, you are
          required to provide us with:
        </p>
        <ul className="list-disc pl-6 mb-4">
          <li>Your full legal name</li>
          <li>Email address</li>
          <li>Full street address including city</li>
          <li>Telephone number</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Security Policy</h2>
        <p>
          Your payment and personal information is always safe. Our Secure
          Sockets Layer (SSL) software is the industry standard and among the
          best software available today for secure commerce transactions. It
          encrypts all of your personal information, including credit card
          number, name, and address, so that it cannot be read over the
          internet.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">User Data Deletion</h2>
        <p>
          Users can request data deletion in Mobile Application from the
          Settings Section.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Children's Privacy</h2>
        <p>
          Online ordering, customer registration for online ordering, and
          customer feedback pages of this website are directed toward and
          designed for use by persons aged 13 or older. We do not establish or
          maintain registrations for any child whom we know to be under the age
          of 13.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Location Data</h2>
        <p>
          We may collect user location data with the user's consent to share
          their location with the Aitisal website or mobile apps to provide the
          user with a quick and better order delivery experience and suggest
          nearby restaurants.
        </p>
        <p className="mt-2">
          In the case of the rider's app, the rider mobile app may collect the
          rider's location information, while the Aitisal Rider app is running
          on the mobile, or in the background to provide real-time order
          location to customers.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Our use of cookies</h2>
        <p>
          Like many websites on the Internet, our website uses cookies. Cookies
          are small strings of data placed on users' personal computer hard
          drives during the exchange of data that happens when your browser
          points to our website.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Data Storage</h2>
        <p>
          We store the information you provide to us and the information we
          collect electronically in our computer databases. We own, maintain and
          operate our computer servers containing our databases. Access to our
          computer servers is controlled by firewalls and security gatekeepers.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Shipping Policy</h2>
        <p>Shipped upon order.</p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Policy Updates</h2>
        <p>
          These are our current privacy and security policies, but we reserve
          the right to change our website and these policies at any time. You
          should check these policies periodically.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Contact Us</h2>
        <p>
          We want you to enjoy your use of our service. If you have any
          questions, or believe that a violation of this policy may have
          occurred, please let us know. Our complete contact information is
          provided on the header or at home page.
        </p>
      </section>
    </div>
  );
}
